import { ScrollView, VStack, View, useBreakpointValue } from "native-base";
import React from "react";

import { useViewport } from "@/contexts/ViewportContext";

import Footer from "../Footer";
import { ContainerProps } from "./types";

const ContainerWeb = ({ Header, children, ...props }: ContainerProps) => {
  const { height } = useViewport();
  const paddingX = useBreakpointValue({
    base: "10%",
    xl: "15%",
    "2xl": "25%",
  });
  return (
    <View h={height} flex={1} bgColor="white.50">
      {Header}
      <ScrollView bgColor="white.50" m={0} p={0} scrollEventThrottle={16}>
        <VStack px={paddingX} {...props}>
          {children}
        </VStack>
      </ScrollView>
      <Footer />
    </View>
  );
};

export default ContainerWeb;
